"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.prettify = void 0;
const types_1 = require("../../types");
const style_1 = require("../../style");
const code_1 = require("../../code");
function prettify(context) {
    const { dataPath, error: { params: { missingProperty } } } = types_1.getTypedContext(context);
    const [prePath, pathExpr, postPath] = style_1.pathDescription(context, 'value');
    const title = style_1.style.title(`The ${prePath}`, context) +
        pathExpr +
        style_1.style.title(`${postPath} is missing required property `, context) +
        style_1.style.pathDescription(missingProperty, context);
    const codeFrame = code_1.printCode('add missing property ' +
        style_1.style.pathDescription(missingProperty, context), context.parsedJson, { dataPath: dataPath.dotOnly, markIdentifier: false });
    return { title, codeFrame };
}
exports.prettify = prettify;
